<template>
    <div class="hedersssss">
      <div class="header">
            <div>
              <img style="width:.26rem;height: .26rem;margin: 0 .1rem 0 .16rem;" src="../assets/img/logo_Lan.svg">
              <img style="width:1.96rem;height: .23rem;" src="../assets/img/wenzi_lan.svg" >
            </div>
            <!-- <img style="width:.22rem;height: .22rem;margin: 0 .22rem 0 .46rem;" src="../assets/img/fangdajing_lan.svg" > -->
            <img style="width:.22rem;height: .18rem;margin-left: .9rem" src="../assets/img/sanhang_lan.svg" @click="show = true" >
        </div>
        <div class="bottom">
        <van-popup v-model="show" position="top" :style="{ height :showShow?4.5+'rem' : '3.5'+'rem'}" :overlay="false">
          <headera @onClose="onClose"></headera>
          <div class="bottom_content">
              <div class="one" @click="loglog('/')">首页</div>
              <div class="one" @click="loglog('companyIntroduction')">走进中检</div>
              <div class="one">
                <div class="one1" @click="showShow= !showShow">
                  <div>我们的服务</div>
                  <div><img :class="showShow? 'suanzhuan ' :'suanzhuan zq'" style="width:.12rem;height: .07rem;margin-left: 2.43rem;" src="../assets/img/shangjiantou.svg" ></div>
                </div>
                <div class="one2" v-if="showShow">
                  <div @click="loglog('businessSectorDetails?categoryId='+item.categoryId)" v-for="(item,ind) in listArr" :key="ind">{{ item.name }}</div>
                </div>
                </div>
              <div class="one" @click="loglog('companyDynamics')">公司动态</div>
              <div class="one" @click="loglog('chat')">联系我们</div>
          </div>
        </van-popup>
        </div>
    </div>
    
</template>

<script>
import headera from '../common/header.vue'
export default {
   components: {headera },
    data() {
      return {
          showShow:true,
          show: false,
          listArr: [
                {name:'大宗资源物资',categoryId:'ea09efe4cf454c1abce5eb59ec3b819c'},
                {name:'工业生产与环境',categoryId:'a65d6259c76e45dbb99abc3bdc7f2dd8'},
                {name:'民生服务与消费品',categoryId:'8e1352d0b267456584da6c8a1311aa62'},
                {name:'贸易及流通服务',categoryId:'8434d5205e7b4c05804486071af9ee9f'},
                {name:'能力与管理提升',categoryId:'ee4ece398f6d4df69b3ce6c6d3e242df'},
                {name:'物权利益保障',categoryId:'e391e1352f5f41a8916974c3bf3e031a'},
            ]
       }
    },
  methods: {
    loglog (e) {
     this.$emit('loglog',e)
    },
    onClose () {
      this.show = false
    }
  },
    created() {},
}
</script>

<style scoped lang="scss">

.suanzhuan{
  transition:all 0.3s ease 0s;
}
.zq{
   transform:rotateZ(180deg);
}
.hedersssss{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: .51rem;
  z-index: 999;
}
   .header{
      display: flex;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: .51rem;
      background: white;
    }
        .bottom{
        position: absolute;
        bottom: 0;
        img{
          float: left;
          width: 1.875rem;
          height: 1.2rem;
        }
        .bottom_content{
          width: 100%;
          position: absolute;
          top: .51rem;
          font-size: .16rem;
          color: rgba(0, 0, 0, 1);
          font-weight: bold;
          .one{
             width: 100%;
             padding: .18rem  .2rem;
             padding-right: 0;
             border-bottom: 0.5px solid rgba(229, 229, 229, 1);  
             box-sizing:border-box ;
          }
          .one:last-child{
            border-bottom: none;  
          }
          .one1{
            display: flex;
            align-items: center;
          }
          .one2{
            width: 100%;
            color: #383838;
            font-size: .12rem;
            font-weight: 400;
            display: flex;
            flex-wrap: wrap;
            div{
              width: 50%;
              margin-top: .2rem;
            }
          }
        }
    }
</style>
<style>
.bottom .van-popup  {
   background: rgba(255, 255, 255, 0.85);
   opacity: 1;
}
</style>